import { createSlice } from '@reduxjs/toolkit';
import AdminApi from "../../../api/AdminApi";
import { showNotification } from "./notification";

type State = {
    data: { [key: number]: { value: string, label: string } },
    isLoading: boolean,
    error: Object | null,
    cellId: number | null
}

const initialState = {
    data: {},
    isLoading: false,
    error: null,
    cellId: null
}

const conversions = createSlice({
    name: 'conversions',
    initialState,
    reducers: {
        fetchConversionsStart: (state: State) => {
            state.isLoading = true;
            state.error = null;
        },
        fetchConversionsSuccess: (state: State, action) => {
            const cellId = action.payload.cellId;
            // @ts-ignore
            if (action.payload && action.payload.data) {
                const newData = action.payload.data.map((conversion: { id: string, name: string }) => {
                    return {
                        value: conversion.id,
                        label: conversion.name
                    };
                });

                // Load additional conversions in case that edit page has old conversions that are not present in current dataset
                if (action.payload.additionalConversions && action.payload.additionalConversions.length) {
                    action.payload.additionalConversions.forEach((additionalConversion: string) => {
                        if (newData && !newData.some((conversion: { value: string, label: string }) => conversion.value === additionalConversion)) {
                            newData.push({ value: additionalConversion, label: additionalConversion });
                        }
                    });
                }

                state.data = {
                    ...state.data,
                    [cellId]: newData
                }
            }
            state.isLoading = false;
            state.error = false;
            state.cellId = cellId;
        },
        fetchConversionsFailed: (state: State, action) => {
            state.isLoading = false;
            state.error = action.payload
        },
        resetConversions: (state: State, action) => {
            if (action.payload.cellId) {
                delete state.data[action.payload.cellId];
            }
        }
    }
});

// Actions
export const {
    fetchConversionsStart,
    fetchConversionsSuccess,
    fetchConversionsFailed,
    resetConversions
} = conversions.actions;

export default conversions.reducer;

// Thunk
export const fetchConversions = (brands: string, additionalConversions: Array<string>, topResults: boolean, cellId: number) => async (dispatch: Function) => {
    try {
        dispatch(fetchConversionsStart());
        const api = new AdminApi();
        const result = await api.getConversions(brands, topResults);
        const payload = {
            data: result,
            additionalConversions,
            cellId
        }
        dispatch(fetchConversionsSuccess(payload));
    } catch (err: any) {
        dispatch(fetchConversionsFailed(err));
        dispatch(showNotification('error', err.message));
    }
}
